<template>
  <div lang="zh" id="app">
      <router-view />
      <div v-if="showOSWarning" class="os-overlay">
        <div class="os-overlay-inner">
          <img src="@/assets/ios.png" alt="">
          <h2 v-html="content['upgrade_please']"></h2>
          <button @click="openSettings">{{ content['upgrade_settings'] }}</button>
        </div>
      </div>
  </div>
</template>
<script>

function iOSversion() {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }
  return 0
}

let ver = iOSversion();

import contentManager from '@/managers/contentManager.js'

  export default {
    name: 'application',
    data(){
      return {
        content:contentManager.content,
        showOSWarning:ver[0] < 13,
        isActive:false,
      }
    },
    methods:{
      openSettings () {
        window.location.href = "App-prefs://prefs:root=Settings";
      },
      openReconfig () {
        this.$router.push('/setuper');
      }
    },
    mounted(){
      if(window.location.toString().indexOf("staging") != -1){
        this.isActive = true
      }
    }
}
</script>
<style>
.os-overlay{
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background:rgba(0,0,0,.8);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:0px 30px;
}
.os-overlay-inner{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width:100%;
  padding:15px 30px 30px 30px;
  background:white;
  border-radius: 15px;
  text-align: center;
}
.os-overlay-inner button{
  outline: none;
  border:none;
  background:none;
  width:100%;
  height:50px;
  color:white;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  background: rgb(255,66,74);
  background: -moz-linear-gradient(left,  rgba(255,66,74,1) 0%, rgba(255,41,133,1) 100%);
  background: -webkit-linear-gradient(left,  rgba(255,66,74,1) 0%,rgba(255,41,133,1) 100%);
  background: linear-gradient(to right,  rgba(255,66,74,1) 0%,rgba(255,41,133,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff424a', endColorstr='#ff2985',GradientType=1 );
  border-radius: 100px;
  margin:0;
}
.os-overlay-inner h2{
  margin-top:0;
  font-size: 20px;
  line-height: 26px;
}
.os-overlay-inner img{
  width:180px;
}
body{
}
* {
  max-width: 100%;
  box-sizing: border-box;
}
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: transparent;
  overflow-x: hidden;
}
#app {
  overflow-x: hidden;
}
[v-cloak] {
  display: none;
}
</style>
